import { registerEnumType } from 'type-graphql'
import { ModelFamilyEnum } from '@ztechapps/common.contract'

export enum VisionExtractorProviderEnum {
  OpenAi = 'OpenAi',
  Gemini = 'Gemini',
  Glm = 'Glm',
  Kimi = 'Kimi',
}

registerEnumType(VisionExtractorProviderEnum, {
  name: 'VisionExtractorProviderEnum',
  description:
    "Vendor that serves a scan route's vision model, derived from the selected model's ModelRate.family — never chosen directly.",
})

/** The two first-party providers `ResolveScanRoute` constrains with the shared output schema. GLM/Kimi route free-text. */
export const SCHEMA_CAPABLE_VISION_PROVIDERS: ReadonlySet<VisionExtractorProviderEnum> = new Set([
  VisionExtractorProviderEnum.Gemini,
  VisionExtractorProviderEnum.OpenAi,
])

/**
 * The vision extractor vendor a `ModelRate.family` routes to, or `null` when that family
 * serves no vision vendor. A total record over `ModelFamilyEnum`, so a new family member is a
 * compile error here until a routing decision is recorded (`backend-gateway-style-guide.md`
 * §2.2 — provider-capability metadata lives beside the enum, never a literal or `if` chain in
 * a consuming action).
 */
export const VISION_PROVIDER_BY_MODEL_FAMILY: Record<ModelFamilyEnum, VisionExtractorProviderEnum | null> = {
  [ModelFamilyEnum.OpenAiGpt4]: VisionExtractorProviderEnum.OpenAi,
  [ModelFamilyEnum.OpenAiGpt5]: VisionExtractorProviderEnum.OpenAi,
  [ModelFamilyEnum.GoogleGemini2]: VisionExtractorProviderEnum.Gemini,
  [ModelFamilyEnum.GoogleGemini3]: VisionExtractorProviderEnum.Gemini,
  [ModelFamilyEnum.MoonshotKimi2]: VisionExtractorProviderEnum.Kimi,
  [ModelFamilyEnum.ZaiGlm]: VisionExtractorProviderEnum.Glm,
  [ModelFamilyEnum.ZaiGlm4]: VisionExtractorProviderEnum.Glm,
  [ModelFamilyEnum.AnthropicClaude4]: null,
  [ModelFamilyEnum.DeepSeekV3]: null,
  [ModelFamilyEnum.MiniMaxM2]: null,
}
